import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { HsButtonModule, HsDividerModule } from '@hsetu/ngui-components';
import { HsLayerDirective } from '@hsetu/ngui-resources';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'kfm-yes-no-dialog',
  standalone: true,
  imports: [CommonModule, HsLayerDirective, HsDividerModule, HsButtonModule],
  templateUrl: './kfm-yes-no-dialog.component.html',
})
export class KfmYesNoDialogComponent {
  private readonly _data = inject<{ title: string; text: string }>(DIALOG_DATA);

  protected readonly dialogRef = inject<DialogRef<boolean>>(DialogRef<boolean>);

  protected readonly title = computed(() => this._data.title);

  protected readonly text = computed(() => this._data.text);
}
